<template lang="pug">
.charts
    #linechart
    .emptychart(v-show="emptyOption")
    .loadingchart(v-show="isLoading")
</template>

<script>
import resizeMixin from './resize.mixin.js'
export default {
  mixins: [resizeMixin],
  props: {
    height: {
      type: Number,
      default: 300
    },
    legend: Array,
    xAxis: Array,
    series: Array,
    predseries: Array,
    lineXAxis: Array,
    areaXAxis: Array
  },
  computed: {
    emptyOption() {
      return _.isEmpty(this.legend) || _.isEmpty(this.xAxis) || _.isEmpty(this.series)
    },
    isLoading() {
      return this.$store.state.chartLoading
    },
    lineOption() {
      return {
        tooltip: {
          trigger: 'axis',
          formatter: function(params, ticket, callback) {
            if(_.isArray(params) && params[0].name == params[1].name){
              let str = `${params[0].name}`
              str = params.filter(item => item.data != '-').reduce((result, item, index) => {
                result += `<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${item.color}"></span>
                          ${item.seriesName} : ${item.data}`
                return result
              }, str)
              return str
            } 
          }
        },
        legend: {
          right: '20',
          bottom: '20',
          data: this.legend
        },
        grid: {
          top: '16%',
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.xAxis
        },
        yAxis: {
          type: 'value',
          axisPointer: {
            snap: true
          }
        },
        series: [{
          name: this.legend[0],
          type: 'line',
          data: this.series,
          type: 'line',
          symbolSize: 5,
          symbol: 'emptyCircle',
          smooth: true,
          itemStyle: { normal: {color: "#4ca63a" }},
          markLine: {
            silent: true,
            label: {
              normal: {
                show: true,
                formatter: function(params, ticket, callback) {
                  return "已优化\n"
                }

              }
            },
            symbol: 'circle',
            lineStyle: {
              normal:{
                type: 'dotted',
                color: '#f2c230'
              }
            },
            data: this.lineXAxis
          }
        },{
          name: this.legend[1],
          type: 'line',
          data: this.predseries,
          type: 'line',
          symbolSize: 5,
          symbol: 'emptyCircle',
          smooth: true,
          itemStyle: { normal: {color: "#407dba" }},
          lineStyle: {
            normal:{
              type: 'dotted',
              color: '#407dba'
            }
          },
          markArea: {
            silent: true,
            label: {
              normal: {
                show: false
              }
            },
            data: this.areaXAxis,
            itemStyle: {
              normal: {
                color: 'rgba(224, 234, 244, 0.4)'
              }
            } 
          }
        }]
      }
    }
  },
  mounted() {
    if(!this.emptyOption){
      this.initChart()
      this.drawChart()
    }
  },
  updated() {
    if(!_.has(this.chart, ["setOption"]) && !this.emptyOption){
      this.initChart()
    }
    !this.emptyOption && this.drawChart()
  },
  methods: {
    initChart() {
      this.chart = echarts.init(document.getElementById('linechart'), null, {height: this.height})
    },
    drawChart() {
      this.chart && this.chart.setOption(this.lineOption)
    },
  },
  // 销毁时将loading置为false
  destroyed() {
      this.$store.commit('CHART_LOADING', false);
      this.chart = {}
  }
}
</script>



// WEBPACK FOOTER //
// predictlinechart.vue?4e61bb62